import { render, staticRenderFns } from "./AllocatedBackorderHistoryContainer.vue?vue&type=template&id=556330d6&scoped=true&"
import script from "./AllocatedBackorderHistoryContainer.vue?vue&type=script&lang=js&"
export * from "./AllocatedBackorderHistoryContainer.vue?vue&type=script&lang=js&"
import style0 from "./AllocatedBackorderHistoryContainer.vue?vue&type=style&index=0&id=556330d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556330d6",
  null
  
)

export default component.exports